import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";

import Login from "../screens/Login";
import Signup from "../screens/Signup";
import Reset from "../screens/ResetPassword.js";
import NewPass from "../screens/NewPassword.js";
import Home from "../screens/Home";
import PostsFeed from "../screens/PostsFeed.js";
import CreatePost from "../screens/CreatePost.js";
import Profile from "../screens/Profile";
import UserProfile from "../screens/UserProfile";

const Routing = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* Public routes */}
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/reset" component={Reset} />
        <Route exact path="/reset/:token" component={NewPass} />
        {/* Guarded routes */}
        <ProtectedRoute exact path="/" component={PostsFeed} />
        <ProtectedRoute exact path="/explore" component={Home} />
        <ProtectedRoute exact path="/create" component={CreatePost} />
        <ProtectedRoute exact path="/profile" component={Profile} />
        <ProtectedRoute exact path="/profile/:userid" component={UserProfile} />

        {/* <Route component={NotFound} /> */}
      </Switch>
    </BrowserRouter>
  );
};

export default Routing;
